import { render, staticRenderFns } from "./GoodsCellSmall.vue?vue&type=template&id=40752b12&scoped=true&"
import script from "./GoodsCellSmall.vue?vue&type=script&lang=js&"
export * from "./GoodsCellSmall.vue?vue&type=script&lang=js&"
import style0 from "./GoodsCellSmall.vue?vue&type=style&index=0&id=40752b12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40752b12",
  null
  
)

export default component.exports